import { APPLICATION_STATUS_TYPE } from 'app/shared/constants/ApplicationStatusConstants';

const APPLICATION_STATUS_DISPLAY_TEXTS = {
    [APPLICATION_STATUS_TYPE.INVITED]: 'Invited To Apply',
    [APPLICATION_STATUS_TYPE.COMPLETED]: 'Received',
    [APPLICATION_STATUS_TYPE.PENDING]: 'In-Progress',
};

const getDisplayTextForApplicationStatus = (status) => {
    switch (status) {
        case APPLICATION_STATUS_TYPE.INVITED:
            return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.INVITED];
        case APPLICATION_STATUS_TYPE.COMPLETED:
            return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.COMPLETED];
        case APPLICATION_STATUS_TYPE.PENDING:
            return APPLICATION_STATUS_DISPLAY_TEXTS[APPLICATION_STATUS_TYPE.PENDING];
        default:
            return status;
    }
};

export {
    getDisplayTextForApplicationStatus,
    APPLICATION_STATUS_TYPE,
};
